import { RefObject, useLayoutEffect, useState } from "react";

const useContainerDimensions = (ref: RefObject<HTMLElement>) => {

    const getDimensions = () => ({
        width: ref?.current?.offsetWidth ?? 0,
        height: ref?.current?.offsetHeight ?? 0,
    })

    const [dimensions, setDimensions] = useState({ width: 0, height: 0 })

    useLayoutEffect(
        () => {
            const handleResize = () => {
                setDimensions(getDimensions())
            }

            if (ref.current) {
                setDimensions(getDimensions())
            }

            window.addEventListener('resize', handleResize)

            return () => {
                window.removeEventListener('resize', handleResize)
            }
        },
        [ref, ref.current]
    );

    return dimensions;
}

export default useContainerDimensions;